import { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ProductBusketContext } from '../../layouts/ProductLayout'
import ProductBrand from './ProductBrand'
import ProductCategory from './ProductCategory'
import { GlobalContext } from '../../appContext/GlobalContext'
import ProductReviews from '../ProductReviews/ProductReviews'
import axios from 'axios'
import toast from 'react-hot-toast'
import './modal_landing.css'
import { useTranslation } from 'react-i18next'

const Product = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { setShowHeader,setOldBusket,setOldTips } = useContext(ProductBusketContext)
  const { productId, loading, autoOrder,setCurrentPaylaterOrder,setBus } = useContext(GlobalContext)

  const [isDetailsVisible, setIsDetailsVisible] = useState(false)

  const handleOpenDetails = () => setIsDetailsVisible(true)
  const handleCloseDetails = () => setIsDetailsVisible(false)
  const [orderAcceptanceStatus, setOrderAcceptanceStatus] = useState(true)

  // OTP handle

  //const [method, setMethod] = useState('');
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const inputsRef = useRef([]); // Reference for all input boxes
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('+40');
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState('');
  const [otp, setOtp] = useState(new Array(6).fill('')); // Array to hold OTP digits
  const [enteredOtp, setEnteredOtp] = useState('');
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [timer, setTimer] = useState(120); // 2 minutes
  const [resendEnabled, setResendEnabled] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(undefined);
  const countryCodes = [
    { code: '+1', country: 'Canada' },
    { code: '+7', country: 'Russia' },
    { code: '+20', country: 'Egypt' },
    { code: '+27', country: 'South Africa' },
    { code: '+31', country: 'Netherlands' },
    { code: '+33', country: 'France' },
    { code: '+34', country: 'Spain' },
    { code: '+36', country: 'Hungary' },
    { code: '+39', country: 'Italy' },
    { code: '+40', country: 'Romania' },
    { code: '+41', country: 'Switzerland' },
    { code: '+43', country: 'Austria' },
    { code: '+44', country: 'United Kingdom' },
    { code: '+45', country: 'Denmark' },
    { code: '+46', country: 'Sweden' },
    { code: '+47', country: 'Norway' },
    { code: '+48', country: 'Poland' },
    { code: '+49', country: 'Germany' },
    { code: '+54', country: 'Argentina' },
    { code: '+55', country: 'Brazil' },
    { code: '+56', country: 'Chile' },
    { code: '+60', country: 'Malaysia' },
    { code: '+61', country: 'Australia' },
    { code: '+62', country: 'Indonesia' },
    { code: '+63', country: 'Philippines' },
    { code: '+64', country: 'New Zealand' },
    { code: '+66', country: 'Thailand' },
    { code: '+67', country: 'Papua New Guinea' },
    { code: '+81', country: 'Japan' },
    { code: '+82', country: 'South Korea' },
    { code: '+86', country: 'China' },
    { code: '+90', country: 'Turkey' },
    { code: '+91', country: 'India' },
    { code: '+92', country: 'Pakistan' },
    { code: '+95', country: 'Myanmar' },
    { code: '+212', country: 'Morocco' },
    { code: '+225', country: 'Ivory Coast' },
    { code: '+237', country: 'Cameroon' },
    { code: '+238', country: 'Cape Verde' },
    { code: '+249', country: 'Sudan' },
    { code: '+254', country: 'Kenya' },
    { code: '+255', country: 'Tanzania' },
    { code: '+256', country: 'Uganda' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' },
    { code: '+267', country: 'Botswana' },
    { code: '+351', country: 'Portugal' },
    { code: '+355', country: 'Albania' },
    { code: '+358', country: 'Finland' },
    { code: '+359', country: 'Bulgaria' },
    { code: '+370', country: 'Lithuania' },
    { code: '+371', country: 'Latvia' },
    { code: '+372', country: 'Estonia' },
    { code: '+373', country: 'Moldova' },
    { code: '+374', country: 'Armenia' },
    { code: '+375', country: 'Belarus' },
    { code: '+386', country: 'Slovenia' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+421', country: 'Slovakia' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+971', country: 'United Arab Emirates' },
    { code: '+993', country: 'Turkmenistan' }
  ];

  useEffect(() => {
    if ('OTPCredential' in window) {
      // alert('OTPCredential API supported!');
  
      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          // Remove the signal to avoid cancellation issues
        })
        .then((otp) => {
          console.log("OTP received:", otp);
          // alert(`OTP received: ${otp.code}`);
  
          if (otp) {
            // Assuming OTP is a 6-digit code
            const otpCode = otp.code.split('');
            // otpCode.forEach((digit, index) => {
            //   handleOtpChange({ value: parseInt(digit) }, index,false);
            // });
            const newOtp = otpCode;
            setOtp(newOtp);
            setEnteredOtp(newOtp.join(''));
          }
        })
        .catch((err) => {
          // alert(`Error retrieving OTP: ${err.message}`);
          console.error('Error retrieving OTP:', err);
        });
    } else {
      // alert('OTPCredential API not supported in this browser.');
    }
  }, []);

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData('text');
    if (/^\d+$/.test(pastedData) && pastedData.length === 6) {
       // Assuming OTP is a 6-digit code
       const otpCode = pastedData.split('');
      //  otpCode.forEach((digit, index) => {
      //    handleOtpChange({ value: parseInt(digit) }, index,false);
      //  });
       const newOtp = otpCode;
       setOtp(newOtp);
       setEnteredOtp(newOtp.join(''));
      e.preventDefault();
    }
  };

  useEffect(() => {
    inputsRef.current.forEach(input => {
      input.addEventListener('paste', handlePaste);
    });

    // Clean up paste event listener
    return () => {
      inputsRef.current.forEach(input => {
        if(input){

          input.removeEventListener('paste', handlePaste);
        }
      });
    };
  }, []);



  useEffect(() => {
    let interval;
    if (otpSent && !resendEnabled) {
      interval = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            setResendEnabled(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpSent, resendEnabled]);

  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus(); // Set focus on the first input
    }
  }, [showVerificationModal]); // This runs when the modal is shown



  const handleLogin = () => {
    // Handle the login process (e.g., OTP verification)
    setShowLoginModal(false);
    setShowOtpModal(true);
  };

  const handleCancel = () => {
    // Close the modals and reset the payment method
    setShowLoginModal(false);
    setShowOtpModal(false);
    setShowVerificationModal(false);
    setCountryCode('+40')
    setPhoneNumber('')
  };
  const handleSendOtp = async () => {
    setOtp(new Array(6).fill('')); // Clear the OTP input boxes
    setEnteredOtp(''); // Clear the enteredOtp state

    if (!phoneNumber) {
      setError('Please enter a valid phone number');
      return;
    }

    const fullNumber = `${countryCode}${phoneNumber}`;

    try {
      let tableId = localStorage.getItem('uuid');
      tableId = JSON.parse(tableId)
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/partners/send-otp`, {
        phoneNumber: fullNumber,
        tableId:tableId
      });

      console.log('OTP sent:', response.data); // For testing, remove in production
      setOtpSent(true);
      setResendEnabled(false); // Disable resend button
      setTimer(120); // Reset timer
      setError('');
      setShowVerificationModal(true);

      toast.success(t('paylater.otp_sent'), {
        position: 'bottom-right',
      })
    } catch (error) {
      console.error('Error sending OTP:', error);
      toast.error(t('paylater.phone_not_match'), {
        position: 'bottom-right',
      })
    }
  };
  const handleOtpChange = (element, index,move=true) => {
    if (isNaN(element.value)) return; // Only allow numbers

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    if(move){

      // Automatically move to the next input box
      if (element.nextSibling && element.value) {
        inputsRef.current[index + 1].focus();
      }
    }

    // Set enteredOtp to be the concatenated OTP digits
    setEnteredOtp(newOtp.join(''));
    // toast.success(t('paylater.otp_resend'), {
    //   position: 'bottom-right',
    // })
  };

  // Handle backspace to move to the previous input
  const handleBackspace = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  // Handle OTP submission
  const handleVerifyOtp = async () => {
    if (!enteredOtp) {
      setError('Please enter the OTP');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/partners/verify-otp`, { phoneNumber: `${phoneNumber}`, otp: enteredOtp,countryCode:`${countryCode}` });
      if (response.status === 200) {

        setShowVerificationModal(false);
        setShowOtpModal(false);
        setCountryCode('+40')
        setPhoneNumber('')
        localStorage.setItem('logged_in_user', JSON.stringify(response.data.user_data[0]))
        toast.success(t('paylater.otp_verified'), {
          position: 'bottom-right',
        })
      }
    } catch (error) {
      toast.error(t('paylater.incor_otp'), {
        position: 'bottom-right',
      })
    }
  };



  const handleResendOtp = () => {
    // Logic to resend OTP
    console.log('Resending OTP...');
    handleSendOtp()// Clear the OTP boxes
    setResendEnabled(false); // Disable the resend button
    setTimer(120); // Reset the timer to 2 minutes
  };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? `0${secs}` : secs}`;
  };


  ////////


  const getOrderAcceptanceStatus = (status) => {
    setOrderAcceptanceStatus(status);
  }
  
  const checkIfPaylaterExist = async () => {
    let tableId = JSON.parse(localStorage.getItem('uuid'));
    if(tableId){
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/partners/paylater_order_exist/${tableId}`);
      if (response.status === 200) {
        let payLaterOrder = response.data.payLaterOrder
        console.log("payLaterOrder exist..",payLaterOrder);
        if(payLaterOrder && payLaterOrder.length){
          localStorage.setItem('currentPaylaterOrder',JSON.stringify(payLaterOrder[0]))
          setCurrentPaylaterOrder(payLaterOrder[0])

          let paylaterBusketTips = JSON.parse(payLaterOrder[0]['basket_details'])

          localStorage.setItem('old_busket',JSON.stringify(paylaterBusketTips['busket']))
          setOldBusket(paylaterBusketTips['busket'])
          localStorage.setItem('merged_busket', JSON.stringify(paylaterBusketTips['busket']));

          localStorage.setItem('old_tips',paylaterBusketTips['tips'])
          setOldTips(paylaterBusketTips['tips'])
          let logged_in_user = JSON.parse(localStorage.getItem('logged_in_user'));
          if(logged_in_user && (logged_in_user['id'] == payLaterOrder[0]['user_id'])){
            console.log("passed..");
          }else{
            console.log("open popup for login");
            setShowOtpModal(true);
          }
        }else{
          localStorage.removeItem('logged_in_user')
          localStorage.removeItem('currentPaylaterOrder')
          localStorage.removeItem('old_busket')
          localStorage.removeItem('old_tips')
          setCurrentPaylaterOrder('')
          setOldBusket('')
          setOldTips('')
        }
      }else{
        localStorage.removeItem('logged_in_user')
        localStorage.removeItem('currentPaylaterOrder')
        localStorage.removeItem('old_busket')
        localStorage.removeItem('old_tips')
        setCurrentPaylaterOrder('')
        setOldBusket('')
        setOldTips('')
      }
    }
  }
  
  useEffect(() => {
    setShowHeader(true)
  }, [setShowHeader])

  useEffect(() => {
    checkIfPaylaterExist()
  }, [])

  useEffect(() => {
    window.localStorage.removeItem('thankyou_code')
    if (!loading && !productId) {
      navigate('/wrongGeneral')
    }
  }, [loading, navigate, productId])

  return !loading ? (
    <div className="p-[20px]">
      {isDetailsVisible ? (
        <ProductReviews onGoBack={handleCloseDetails} />
      ) : (
        <>
          <ProductBrand
            onReviewsClick={handleOpenDetails}
            auto_order={autoOrder}
            orderAcceptanceStatus={orderAcceptanceStatus}
          />
          <ProductCategory setOrderAcceptanceStatus={getOrderAcceptanceStatus} restId={productId} />
        
          {/* OTP Func started*/}
        
          

      {showLoginModal && (
        <div className="modal">
          <div className="modal-content-land" style={{ height: '254px' }}>
            <h3>
              <img
                alt="System"
                src="/assets/images/info-orange.svg"
                style={{
                  height: '35px',
                  width: '35px'
                }}
              /></h3>
            <p>{t('paylater.login_proceed')}</p>
            <div className='modal-buttons'>
              <button onClick={handleCancel}>{t('paylater.cancel')}</button>
              <button onClick={handleLogin}>{t('paylater.login')}</button>

            </div>
          </div>
        </div>
      )}

      {showOtpModal && (
        <div className="modal">
          <div className="modal-content-land" style={{ height: '291px' }}>
            <h3 className='heading_mob_num'>{t('paylater.already_open')}</h3>
            <h3>
              <img
                alt="System"
                src="/assets/images/open-bill.svg"
                style={{
                  height: '35px',
                  width: '35px'
                }}
              /></h3>
            <h3 className='heading_mob_num_2'>{t('paylater.already_open_phone')}</h3>
            <div className="phone-input-container">
              <select
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                className="country-code-dropdown"
              >
                {countryCodes.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code}
                  </option>
                ))}
              </select>

              <input
                type="tel"
                placeholder="Enter mobile number"
                value={phoneNumber}
                onChange={(e) => {
                  // Allow only numbers
                  const numericValue = e.target.value.replace(/\D/g, "");
                  setPhoneNumber(numericValue);
                }}
                className="phone-number-input"
              />
            </div>
            <div className='modal-buttons' style={{justifyContent:'flex-end'}}>

              {/* <button onClick={handleCancel}>Cancel</button> */}
              <button onClick={handleSendOtp}>Send OTP</button>
            </div>
          </div>
        </div>
      )}


      {/* OTP Verification Modal (Step 3) */}
      {showVerificationModal && (
        <div className="modal">
          <div className="modal-content">
            <h3 className='heading_otp_num'>{t('paylater.otp_verify')}</h3>
            <h3 className='heading_otp_num_1'>{t('paylater.otp_desc')}</h3>
            <h3 className='heading_otp_num_2'>{`${countryCode}${phoneNumber}`}</h3>
            <h3 className='heading_otp_num_3'>{formatTime(timer)}</h3>


           
            {/* OTP input boxes */}
            <div className="otp-input-container">
              {otp.map((digit, index) => (
                <input
                key={index}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(e.target, index)}
                onKeyDown={(e) => handleBackspace(e, index)}
                ref={(el) => (inputsRef.current[index] = el)}
                className="otp-input"
                onPaste={handlePaste}
                inputMode="numeric" // Ensures numeric keyboard
                autocomplete="one-time-code" // Enables OTP autofill prompt in Google Keyboard
                />
              ))}
            </div>

            <div className='resend-otp-cont'>
              <h3>{t('paylater.otp_not_rec')}</h3>
              <button onClick={handleResendOtp}>Resend</button>
            </div>


            <div className='modal-buttons'>
              <button onClick={handleCancel}>Cancel</button>
              <button onClick={handleVerifyOtp}>Verify OTP</button>
            </div>

          </div>
        </div>
      )}

          {/* OTP Func ended */}
        </>
      )}
    </div>
  ) : null
}

export default Product
